const HomeAirfields = {
  10: [
    'Gravesend or Rochford',
    'Northolt',
    'North Weald',
    'Martlesham',
    'Kenley',
    'Biggin Hill',
    'Tangmere',
    'Croydon',
    'Hornchurch',
    'Hendon',
    'Debden or Manston',
  ],
  11: [
    'Pembury',
    'Exeter',
    'Exeter',
    'St Eval',
    'Middle Wallop',
    'Middle Wallop',
    'Middle Wallop',
    'Middle Wallop',
    'Exeter',
    'Exeter',
    'Pembury',
  ],
  12: [
    'Kirton or Leconfield',
    'Coltishall',
    'Coltishall',
    'Church Fenton',
    'Duxford',
    'Duxford',
    'Duxford',
    'Wittering',
    'Digby',
    'Digby',
    'Collyweston or Fowlmere',
  ],
  13: [
    'Catterick',
    'Catterick',
    'Acklington',
    'Acklington',
    'Turnhouse',
    'Turnhouse',
    'Turnhouse',
    'Drem',
    'Drem',
    'Grangemouth or Wick',
    'Grangemouth or Wick',
  ],
};
export default HomeAirfields;
